import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Textarea } from '@fiverr-private/fit';
import FileReview from '../FileReview';
import FilerrShape from '../../PropsShape/FilerrShape';
import * as ReviewsSelectors from '../../selectors/reviews';
import * as CommentsSelectors from '../../selectors/comments';
import './style.scss';

class CommentsSummaryToSubmitModalBody extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            review: props.review
        };
    }

    render() {
        const {
            review
        } = this.state;

        const {
            pendingCommentsIdsLength,
            setCommentsSummaryMessage,
            commentsSummaryMessage
        } = this.props;

        return (
            <div className="comments-summary-modal-body">
                <Textarea className={classNames('summary-textarea', { 'with-comments': !!pendingCommentsIdsLength })}
                    onChange={setCommentsSummaryMessage}>
                    {commentsSummaryMessage}
                </Textarea>
                <div className="summary-reviews">
                    {review.map((item, index) => <FileReview key={index} item={item}/>)}
                </div>
            </div>
        );
    }
}

CommentsSummaryToSubmitModalBody.propTypes = {
    review: PropTypes.arrayOf(PropTypes.shape({
        filerr: FilerrShape,
        commentsCount: PropTypes.number
    })),
    pendingCommentsIdsLength: PropTypes.number,
    setCommentsSummaryMessage: PropTypes.func,
    commentsSummaryMessage: PropTypes.string
};

CommentsSummaryToSubmitModalBody.defaultProps = {
    review: [],
    pendingCommentsIdsLength: 0
};

const mapStateToProps = (state) => {
    const pendingCommentsIds = CommentsSelectors.getPendingIds(state);

    return ({
        pendingCommentsIdsLength: pendingCommentsIds.length,
        review: ReviewsSelectors.getReview(state, pendingCommentsIds)
    });
};

export default connect(mapStateToProps)(CommentsSummaryToSubmitModalBody);
